import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useShop } from "../context/ShopContext";
import { useAuth } from "../components/AuthContext"; // 👈 Add this
import apiClient from "../apiClient";

const SignInPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const {
    setShopId,
    setToken,
    setshopName,
    setuserId,
    setuserName,
    setcompanyId,
    setGroupId
  } = useShop();

  const { isAuthenticated, login } = useAuth(); // 👈 Access auth state


 useEffect(() => {
  // If already logged in and trying to access /signin, redirect to last visited page
  if (isAuthenticated) {
    const lastVisited = localStorage.getItem("lastVisitedPath") || "/home";
    navigate(lastVisited, { replace: true });
  }
}, [isAuthenticated, navigate]);

  const showToast = (message, type = "error") => {
    toast.dismiss();
    type === "error" ? toast.error(message) : toast.success(message);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username.trim() || !password.trim()) {
      showToast(
        !username.trim() && !password.trim()
          ? "Please enter username and password."
          : !username.trim()
          ? "Please enter username."
          : "Please enter password."
      );
      return;
    }

    setLoading(true);
debugger;
    try {
      const response = await apiClient.post(
                      "/Login/GetUserLogin",
        {
          userName: username,
          password: password,
        },
        {
          headers: {
            "Content-Type": "application/json",
            accept: "*/*",
          },
        }
      );


      console.log("Sigin: ",response)
      
      if (response.status === 200 && response.data?.data) {
        const {
          shopId,
          tokenString,
          shopName,
          userId,
          userName,
          companyId,
          groupId,
        } = response.data.data;

        // ✅ AuthContext login (for route protection)
        login(tokenString); // 👈 Store in AuthContext

        // ✅ Set app state in ShopContext
        setShopId(shopId);
        setToken(tokenString);
        setshopName(shopName);
        setuserId(userId);
        setuserName(userName);
        setcompanyId(companyId);
        setGroupId(groupId);

        // ✅ Store in localStorage
        localStorage.setItem("shopId", shopId);
        localStorage.setItem("tokenString", tokenString);
        localStorage.setItem("shopName", shopName);
        localStorage.setItem("userId", userId);
        localStorage.setItem("userName", userName);
        localStorage.setItem("companyId", companyId);
        localStorage.setItem("groupId", groupId);

        showToast("Login successful!", "success");

        // ✅ Navigate to home
        navigate("/home");
      } else {
        showToast(response.data?.message || "Invalid username and password.");
      }
    } catch (err) {
  if (err?.response?.status !== 401 && err?.response?.status !== 403) {
    showToast("Something went wrong. Please try again.");
  }
} finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex flex-column flex-lg-row flex-column-fluid">
      <ToastContainer />
      {/* Left Side with Background Image */}
      <div
        className="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center"
        style={{ backgroundImage: "url(assets/media/misc/auth-bg.png)" }}
      >
        <div className="d-flex flex-column flex-center p-6 p-lg-10 w-100">
          <a href="#" className="mb-0 mb-lg-20">
            <img
              alt="Logo"
              src="assets/media/logos/Logo_wineshop.png"
              className="h-25px h-lg-40px"
            />
          </a>
          <img
            className="d-none d-lg-block mx-auto w-200px w-lg-55 w-xl-200px mb-10 mb-lg-20 w-lg-30px"
            src="assets/media/wine.png"
            style={{ width: "100px" }}
            alt=""
          />
          <h1 className="d-none d-lg-block text-white fs-2qx fw-bold text-center mb-7">
            Manage Your Wine Collections
          </h1>
          <div className="d-none d-lg-block text-white fs-base text-center">
            Easily organize and track your wine inventory with detailed categorization and real-time updates.
            <br />
            Keep your wine collection refined, well-stocked, and ready for every customer’s taste.
          </div>
        </div>
      </div>

      {/* Right Side with Sign In Form */}
      <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10">
        <div className="d-flex flex-center flex-column flex-lg-row-fluid">
          <div className="w-lg-500px p-10">
            <form className="form w-100" noValidate onSubmit={handleSubmit}>
              <div className="text-center mb-11">
                <h1 className="text-gray-900 fw-bolder mb-3">Sign In</h1>
              </div>

              <div className="fv-row mb-8">
                <input
                  type="text"
                  id="username"
                  className="form-control form-control-lg"
                  placeholder="Username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  disabled={loading}
                />
              </div>

              <div className="fv-row mb-3">
                <input
                  type="password"
                  id="password"
                  className="form-control form-control-lg"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                />
              </div>

              <div className="d-grid mb-10">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "Logging in..." : "Login"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignInPage;
